// Theme toggle. The initial theme is applied inline in <head> to avoid a flash;
// this only wires the button and keeps its accessible state in sync.
document.addEventListener('DOMContentLoaded', ()=>{
    const themeToggle = document.getElementById('theme-toggle');
    const htmlElement = document.documentElement;
    if (!themeToggle) return;
    const syncToggleState = ()=>{
        const isDark = htmlElement.getAttribute('data-theme') === 'dark';
        themeToggle.setAttribute('aria-pressed', String(isDark));
        themeToggle.setAttribute('aria-label', isDark ? 'Switch to light mode' : 'Switch to dark mode');
    };
    syncToggleState();
    themeToggle.addEventListener('click', ()=>{
        const newTheme = htmlElement.getAttribute('data-theme') === 'dark' ? 'light' : 'dark';
        htmlElement.setAttribute('data-theme', newTheme);
        localStorage.setItem('theme', newTheme);
        syncToggleState();
    });
});

//# sourceMappingURL=special-ed.b865d66d.js.map
